<div class="donut" [ngClass]="size"></div>
<div class="loader-content"><ng-content></ng-content></div>
